<div class="search-container-details">
    <div class="tab-title-icon">
        <cll-icon class="tab-icon" type="outlined">inventory_2</cll-icon>
        <div class="accordion-sub-title-accordion">
            <span class="detail-table-title">Packages</span>
            <span class="detail-table-sub-title">Previous packages associated with the client</span>
        </div>
    </div>
</div>

<div class="tabs-table-container">
    <table class="cll-table">
        <thead>
        <tr>
            <th>Reference</th>
            <th>Created</th>
            <th>Commissioner</th>
            <th>Postcode</th>
            <th>Open</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
            @if (pageResult(); as request) {
                @if (request.isLoading) {
                  <cll-spinner />
                }
              
                @if (request.error; as error) {
                  {{ error }}
                }
              
                @if (request.value; as page) {
                  @if (page.data.length > 0) {
                    @for (packageRow of page.data; track packageRow.id) {
                      <tr>
                        <td>{{ packageRow.reference }}</td>
                        <td>{{ packageRow.created_at | date: 'dd/MM/yyyy HH:mm' }}</td>
                        <td>{{ packageRow.commissioner?.name }}</td>
                        <td>{{ packageRow.address?.post_code }}</td>
                        <td>
                          @if (packageRow.open) {
                            <cll-icon class="check-icon" [size]="19">check_circle</cll-icon>
                          } @else {
                            <cll-icon class="cancel-icon" type="outlined" [size]="19">cancel</cll-icon>
                          }
                        </td>
                        <td class="align-right">
                          <button cll-icon-button
                                  [cllMenuTriggerFor]="menu"
                                  (click)="$event.stopPropagation()">
                            <cll-icon>more_vert</cll-icon>
                          </button>
              
                          <ng-template #menu>
                            <cll-menu>
                              <a cllMenuItem
                                 [routerLink]="['/packages/', packageRow.id]"
                                 [queryParams]="{ type: 'my-packages' }"
                                 target="_blank"
                                 rel="noopener noreferrer">
                                <cll-icon>open_in_new</cll-icon>
                                View package
                              </a>
                            </cll-menu>
                          </ng-template>
                        </td>
                      </tr>
                    }
                  } @else {
                    <tr>
                      <td colspan="6" class="no-data-row">
                        <div class="no-data-wrapper-tabs">
                          No packages found.
                        </div>
                      </td>
                    </tr>
                  }
                }
              }
                      
        </tbody>
    </table>
</div>

<app-pagination-card (page)="setPage($event)" [meta]="meta()" />
